var $mask,
	$maskWidth,
	$maskHeight;

jQuery( 'document' ).ready( function() {
	jQuery( 'a.supersized' ).click( function( e ) {
		e.preventDefault();
		if( jQuery( '#mask' ).length > 0 ) {
			destroyOverlay( -1 ); 
		}
		createOverlay( jQuery( this ) );
	});
	// Make sure the overlay get's destroyed when we hit escape...
	jQuery( 'body' ).on( 'keydown', function( e ) {
		destroyOverlay( e.which );
	});
});
function createOverlay( $elm ) {
	// Get the screen height and width
	$maskHeight = jQuery(window).height();
	$maskWidth = jQuery(window).width();
	// Create the mask
	$mask = jQuery( '<div></div>' ).attr( 'id', 'mask' ).css( { 'width' : $maskWidth, 'height' : $maskHeight } );
	$supersized = jQuery( '<ul></ul>' ).attr( 'id', 'supersized' );
	// Add supersized to the mask
	$mask.append( $supersized );
	// Create all the elements we'll need and attach them to the container
	$mask.append( '<div id="prevthumb"></div>' );
	$mask.append('<div id="nextthumb"></div>');
	$mask.append('<a id="prevslide" class="load-item"></a>');
	$mask.append('<a id="nextslide" class="load-item"></a>');
	$mask.append('<div id="thumb-tray" class="load-item"><div id="thumb-back"></div><div id="thumb-forward"></div></div>');
	$mask.append('<div id="progress-back" class="load-item"><div id="progress-bar"></div></div>');
	$mask.append('<div id="controls-wrapper" class="load-item"><div id="controls"><a id="play-button"><img id="pauseplay" src="/wp-content/themes/ffr/assets/images/supersized/pause.png"/></a><div id="slidecounter"><span class="slidenumber"></span> / <span class="totalslides"></span></div><div id="slidecaption"></div><a id="closeBtn">Close</a><a id="tray-button"><img id="tray-arrow" src="/wp-content/themes/ffr/assets/images/supersized/button-tray-down.png"/></a></div></div>');
	jQuery( '#closeBtn', $mask ).click(function() {
		destroyOverlay( -1 )
	});
	// Add the mask to the body
	jQuery( 'body' ).prepend( $mask );
	// Prevent the window from scrolling (or even showing scroll bars)
	jQuery( 'html' ).css( { 'overflow' : 'hidden' } );
	// Add the window resize function
	jQuery( window ).resize( function() {
		$maskHeight = jQuery( window ).height();
		$maskWidth = jQuery( window ).width();
		$mask.css( { 'width' : $maskWidth, 'height' : $maskHeight } );
	});
	// Fade the mask in
	$mask.stop().animate( { 'opacity' : 1 }, 500, function() {
		// Get the data and images associated with this client
		getData( $elm );
	});
	return;
}
function destroyOverlay( $key ) {
	// If a click or escape keypress is registered...
	if( $key == -1 || $key == 27) {
		// Fade out overlay
		$mask.stop().animate( { 'opacity' : 0 }, 500, function() {
			// Kill all timing intervals
			clearInterval(jQuery.supersized.vars.slideshow_interval);
			// Then destroy it.
			$mask.remove();
			// Put the body and html back to normal (show scroll bars)
			jQuery( 'html' ).css( { 'overflow' : 'auto' } );
		});
	}
	return;
}
function getData( $elm ) {
	// Get the slide start value based on the image we clicked
	$start = jQuery( '#content .supersized' ).index( $elm ) + 1;
	// Do an AJAX request to get relavant data
	jQuery.ajax( {
		type: 'POST',
		url: ajax_object.ajaxurl,
		data: 'id=' + post_id,
		// If successful
		success: function( $retval ) {
			jQuery( 'document' ).ready( function() {
				jQuery.supersized({
					// Functionality
					slide_interval          :   5000,		// Length between transitions
					transition              :   1, 			// 0-None, 1-Fade, 2-Slide Top, 3-Slide Right, 4-Slide Bottom, 5-Slide Left, 6-Carousel Right, 7-Carousel Left
					transition_speed		:	700,		// Speed of transition
					// Components							
					slide_links				:	'blank',	// Individual links for each slide (Options: false, 'num', 'name', 'blank')
					slides 					:  	$retval,
					start_slide				:	$start,
					autoplay				:	0,
					fit_landscape			:	0,
					fit_portrait			:	0,
					fit_always				:	1
				});
		    });
		},
		dataType: 'json'
	// Otherwise alert that there is a problem
	}).fail( function( jqXHR, textStatus ) {
		alert( "Request failed: " + textStatus );
	});
}